<div class="brick" [style]="style"></div>
